import React, { useState } from 'react';
import axios from 'axios';

const API = window.location.origin + '/api';

const Feedback = () => {
  const token = localStorage.getItem('token');
  const dealer = JSON.parse(localStorage.getItem('dealer') || '{}');
  const headers = { Authorization: `Bearer ${token}` };

  const [category, setCategory] = useState('product');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        name: dealer.company_name,
        email: dealer.email,
        company: dealer.company_name,
        message: `[${category.toUpperCase()}] ${message}`,
      }, { headers });
      setSent(true);
      setMessage('');
    } catch (err) {}
    setLoading(false);
  };

  if (sent) return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Feedback & Suggestions</h1>
      <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-green-600 text-2xl">✓</span>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">Thank you!</h3>
        <p className="text-gray-500 text-sm mb-6">Your feedback has been sent to the BullionX team.</p>
        <button onClick={() => setSent(false)}
          className="px-4 py-2 rounded-lg text-white text-sm font-medium"
          style={{backgroundColor:'#B8860B'}}>
          Send another
        </button>
      </div>
    </div>
  );

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Feedback & Suggestions</h1>
      <p className="text-gray-400 text-sm mb-6">Help us improve BullionX — suggest new products, features or improvements.</p>

      <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm max-w-2xl">

        <div className="mb-6">
          <label className="text-xs text-gray-500 mb-2 block font-medium">Category</label>
          <div className="grid grid-cols-3 gap-2">
            {[
              { key: 'product', label: '🪙 New Product', desc: 'Request a new coin or bar' },
              { key: 'feature', label: '⚡ New Feature', desc: 'Suggest platform improvements' },
              { key: 'other', label: '💬 Other', desc: 'General feedback' },
            ].map(c => (
              <button key={c.key} type="button" onClick={() => setCategory(c.key)}
                className={`p-3 rounded-lg border text-left transition-all ${category === c.key ? 'border-yellow-400 bg-yellow-50' : 'border-gray-200 hover:border-gray-300'}`}>
                <p className="text-sm font-medium text-gray-900">{c.label}</p>
                <p className="text-xs text-gray-400 mt-0.5">{c.desc}</p>
              </button>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <label className="text-xs text-gray-500 mb-2 block font-medium">Your suggestion</label>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            rows={5}
            className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none resize-none"
            placeholder={
              category === 'product' ? 'e.g. Please add Sovereign 1oz gold coin from the Royal Mint...' :
              category === 'feature' ? 'e.g. I would like to see automatic price calculation based on spot...' :
              'Your feedback...'
            }
          />
        </div>

        <div className="bg-gray-50 rounded-lg p-3 mb-6">
          <p className="text-xs text-gray-500">Sending as: <strong>{dealer.company_name}</strong> ({dealer.email})</p>
        </div>

        <button onClick={handleSubmit} disabled={loading || !message.trim()}
          className="w-full py-3 rounded-lg text-white font-semibold text-sm disabled:opacity-50"
          style={{backgroundColor:'#1a1a2e'}}>
          {loading ? 'Sending...' : 'Send Feedback'}
        </button>
      </div>
    </div>
  );
};

export default Feedback;
